var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderCancelled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 75,
    viewBox: "0 0 150 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6146 33.4656V74M77.3923 19.647L45.6146 11.8545L37.3788 14.0141L35.3198 14.5541M45.6146 74L79.2082 61.1027M45.6146 74L12.021 61.1027V37.2589M79.2082 34.6939V51.2615M15.8979 19.647L29.143 16.1738",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 32.1932L15.9011 19.0469L46.2279 33.0934L33.8145 46.3838L12.024 37.2798L0 32.1932Z",
    fill: "#EB4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9377 41.1496L54.6333 30.5233L77.7632 19.1191L90.11 29.7906L79.2148 34.7039L66.9377 41.1496Z",
    fill: "#EB4848"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4505 67.9839L11.4956 0.5",
    stroke: "#383434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M116.257 19.4277C108.592 19.4277 102.378 21.8503 102.378 24.8387V63.9929C102.378 66.9813 108.592 69.4039 116.257 69.4039C123.923 69.4039 130.137 66.9813 130.137 63.9929V24.8387C130.137 21.8503 123.923 19.4277 116.257 19.4277Z",
    fill: "#F2CA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130.137 55.4307C130.137 58.4589 123.923 60.9138 116.257 60.9138C108.592 60.9138 102.378 58.4589 102.378 55.4307",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.137 45.4238C130.137 47.6635 123.923 49.479 116.257 49.479C108.592 49.479 102.378 47.6635 102.378 45.4238",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.137 35.3584C130.137 37.598 123.923 39.4136 116.257 39.4136C108.592 39.4136 102.378 37.598 102.378 35.3584",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M130.137 25.2832C130.137 27.5228 123.923 29.3384 116.257 29.3384C108.592 29.3384 102.378 27.5228 102.378 25.2832",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.934 69.0265C143.15 69.0265 149 63.0153 149 55.6002C149 48.185 143.15 42.1738 135.934 42.1738C128.717 42.1738 122.867 48.185 122.867 55.6002C122.867 63.0153 128.717 69.0265 135.934 69.0265Z",
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.857 51.5693L132.017 59.6251",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.017 51.5693L139.857 59.6251",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCancelled);
export default __webpack_public_path__ + "static/media/orderCancelled.0193aa96a7edf0ec7f02abab7997642a.svg";
export { ForwardRef as ReactComponent };